import { render } from "./SendOtp.vue?vue&type=template&id=fcf43240"
import script from "./SendOtp.vue?vue&type=script&lang=js"
export * from "./SendOtp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Build Apps\\jlm_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__